import { useState } from "react"
import { Helmet } from "react-helmet-async"
import { Link, useSearchParams } from "react-router-dom"
import { resetPassword } from "../services/userService"

export default function ResetPassword() {
    const [searchParams] = useSearchParams()
    const token = searchParams.get("token")

    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [error, setError] = useState("")
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [completed, setCompleted] = useState(false)

    const handleSubmit = async (event) => {
        event.preventDefault()

        if (password.length < 8) {
            setError("Password must be at least 8 characters long")
            return
        }
        if (password !== confirmPassword) {
            setError("Passwords do not match")
            return
        }

        setIsSubmitting(true)
        setError("")

        try {
            await resetPassword(token, password)
            setCompleted(true)
        } catch (err) {
            setError(err.message || "Something went wrong. Please try again.")
        } finally {
            setIsSubmitting(false)
        }
    }

    return (
        <div className="auth-container">
            <Helmet>
                <title>Choose a New Password - Chaperon</title>
                <meta
                    name="description"
                    content="Choose a new password for your Chaperon account."
                />
            </Helmet>

            {/* Left Side - Brand/Image Section */}
            <div
                className="auth-image-section"
                style={{
                    backgroundImage: "url(/image/galina-mountain-hike.jpg)",
                }}
            >
                <div className="auth-brand-content">
                    <h1>Almost There</h1>
                    <p>
                        Choose a new password and get back to exploring safely.
                    </p>
                </div>
            </div>

            {/* Right Side - Reset Form */}
            <div className="auth-form-section">
                <div className="auth-form-container">
                    {!token ? (
                        <>
                            <div className="auth-form-header">
                                <h1>Invalid Link</h1>
                                <p>
                                    This password reset link is missing its
                                    token. Please use the link from your email,
                                    or request a new one.
                                </p>
                            </div>
                            <Link
                                to="/user/forgot-password"
                                className="btn-auth-primary"
                            >
                                Request a New Link
                            </Link>
                        </>
                    ) : completed ? (
                        <>
                            <div className="auth-form-header">
                                <h1>Password Updated</h1>
                                <p>
                                    Your password has been changed. Sign in with
                                    your new password to continue.
                                </p>
                            </div>
                            <Link to="/user/login" className="btn-auth-primary">
                                Sign In
                            </Link>
                        </>
                    ) : (
                        <>
                            <div className="auth-form-header">
                                <h1>New Password</h1>
                                <p>
                                    Choose a new password for your account
                                    (minimum 8 characters)
                                </p>
                            </div>

                            {error && (
                                <div className="alert alert-danger" role="alert">
                                    {error}
                                </div>
                            )}

                            <form
                                onSubmit={handleSubmit}
                                noValidate
                                className="auth-form"
                            >
                                <div className="mb-3">
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="password"
                                        name="password"
                                        value={password}
                                        onChange={(e) =>
                                            setPassword(e.target.value)
                                        }
                                        placeholder="New password"
                                        required
                                        autoComplete="new-password"
                                    />
                                </div>

                                <div className="mb-3">
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="confirmPassword"
                                        name="confirmPassword"
                                        value={confirmPassword}
                                        onChange={(e) =>
                                            setConfirmPassword(e.target.value)
                                        }
                                        placeholder="Confirm new password"
                                        required
                                        autoComplete="new-password"
                                    />
                                </div>

                                <button
                                    type="submit"
                                    className="btn-auth-primary"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? (
                                        <>
                                            <span
                                                className="spinner-border spinner-border-sm me-2"
                                                role="status"
                                                aria-hidden="true"
                                            ></span>
                                            Updating...
                                        </>
                                    ) : (
                                        "Update Password"
                                    )}
                                </button>

                                <div className="text-center mt-3">
                                    <Link
                                        to="/user/login"
                                        className="auth-link"
                                    >
                                        Back to Sign In
                                    </Link>
                                </div>
                            </form>
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}
